import React, { useEffect, useRef } from 'react';
import { motion } from 'framer-motion';
import { useTheme } from '../context/ThemeContext';

const MouseFollower = () => {
  const { themeColor, cursorPosition } = useTheme();

  return (
    <motion.div
      className="fixed pointer-events-none z-0"
      animate={{
        x: cursorPosition.x - 200,
        y: cursorPosition.y - 200,
      }}
      transition={{
        type: 'spring',
        stiffness: 50,
        damping: 20,
        mass: 0.5
      }}
    >
      <div
        className="w-[400px] h-[400px] rounded-full blur-[100px] opacity-30"
        style={{ backgroundColor: themeColor.primary }}
      />
    </motion.div>
  );
};

export default MouseFollower;
